import { useEffect, useState } from "react";
import WarehouseTable from "./WarehouseTable";
import WarehouseForm from "./WarehouseForm";
import useApi from "../../../api";
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import { getQueryVariables } from "../../../utils";
import { useSearchParams } from "react-router-dom";


const GET_WAREHOUSES = gql`
  query GetWarehouses(
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    warehouses(
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          dbId
          isDefault
          location
          name
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

function Warehouse() {
  const [formData, setFormData] = useState<any>({})
   const [searchParams, setSearchParams] = useSearchParams();
  const [warehouses, setWarehouses] = useState<any>()
  const [isOpenWarehouseForm, setIsOpenWarehouseForm] = useState<boolean>(false)
  const api = useApi()


  const { data, loading, error, refetch } = useQuery(GET_WAREHOUSES, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);


  const fetchWarehouses = () => {
    refetch();
  }

  return (
    <>
      <div>
        <h3>Warehouse</h3>
        <button
          className="my-2 float-right bg-primary-400 py-2 px-5 w-full md:w-[200px] text-white rounded-md hover:bg-primary-500 transition-all duration-150 ease-linear"
          onClick={() => {
            setIsOpenWarehouseForm(true);
            setFormData({ tax_rates: [{ is_active: true }] });
          }}
        >
          Add Warehouse
        </button>
          
        <div className="overflow-x-auto w-full">
          <WarehouseTable data={data?.warehouses?.edges || []} refresh={fetchWarehouses}/>
        </div>
        {isOpenWarehouseForm && (
          <WarehouseForm
            isOpen={isOpenWarehouseForm}
            onClose={() => setIsOpenWarehouseForm(false)}
            refresh={fetchWarehouses}
          />
        )}
      </div>
    </>
  );
}

export default Warehouse;
